export default {"src":"/_next/static/media/logo-yellow.19b721c3.svg","height":177,"width":902,"blurWidth":0,"blurHeight":0};